import { Dialog, Transition } from '@headlessui/react';

import { XIcon } from '@heroicons/react/outline';
import * as React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { SUPER_ADMIN_ROLE, APP_PATH } from '@/config';

import { useAuth } from '@/lib/auth';
import { useAuthorization, ROLES } from '@/lib/authorization';
import { Icon1 } from '@/assets/img/icon-1';
import { Calender } from '@/assets/img/Calender';
import { Services } from '@/assets/img/Services';
import { Schedule } from '@/assets/img/Schedule';
import { OtherMenu1 } from '@/assets/img/other-menu-1';
import { OtherMenu2 } from '@/assets/img/other-menu-2';
import { OtherMenu3 } from '@/assets/img/other-menu-3';
import { OtherMenu4 } from '@/assets/img/other-menu-4';
import { OtherMenu5 } from '@/assets/img/other-menu-5';
import { OtherMenu6 } from '@/assets/img/other-menu-6';
import { OtherMenu7 } from '@/assets/img/other-menu-7';
import { Maps } from '@/assets/img/maps';
import { OtherMenu9 } from '@/assets/img/other-menu-9';
import { OtherMenu8 } from '@/assets/img/other-menu-8';
import { OtherMenu10 } from '@/assets/img/other-menu-10';

import { CustomerIcon2 } from '@/assets/img/customer-icon';

import { Icon2 } from '@/assets/img/icon-2';
import { ReactComponent as MenuBackIcon } from '@/assets/img/menu-back-icon.svg';
import { ReactComponent as ArrowIcon } from '@/assets/img/down-arrow.svg';

import Icon3 from '@/assets/img/icon-3.svg';
import Icon4 from '@/assets/img/icon-4.svg';
import Icon10 from '@/assets/img/message1.svg';
import Icon5 from '@/assets/img/icon-5.svg';
import Icon6 from '@/assets/img/icon-up.svg';
import Icon7 from '@/assets/img/icon_holiday_cal.svg';
import Icon8 from '@/assets/img/pay.png';
import Icon9 from '@/assets/img/review.png';
import Customer from '@/assets/img/customer-1.svg';
import MenuPetIcon from '@/assets/img/pets.svg';
import Marker from '@/assets/img/marker.png';
import storage from '@/utils/storage';
import { TopHeader } from './TopHeader';
import '@/styles/New-index.scss';
import '@/styles/dashboard.scss';
import '@/styles/services.scss';
import '@/styles/New-responsive.scss';
import './MainLayout.scss';
import { UseScreenOrientation as useScreenOrientation } from '@/utils/Orientation';
import moment from 'moment';
import { IntakeFormMenuIcon } from '@/assets/img/intake-form-menu';
import { EmilyOtherMenu } from '@/assets/img/emilty-other-menu';
import { EmilyAIIcon } from '@/assets/img/emily-ai-icon';

type SideNavigationItem = {
  name: string;
  to: string;
  icon: any;
};

const SideNavigation = ({ sidebarOpen, setSidebarOpen }: MobileSidebarProps) => {
  const location = useLocation();
  const { logout, user } = useAuth();
  const saToken = storage.getSAToken();
  const routeArr = [];
  EmilyOtherMenu;
  const permissions = user?.permissions;
  const [showOthers, setShowOthers] = React.useState(false);

  if (user?.businessUserRole?.name == SUPER_ADMIN_ROLE) {
    // if (permissions?.dashboard && permissions?.dashboard.showMenu === true) {
    //   routeArr.push({ name: 'Payouts', to: './payout', icon: Icon8 });
    // }
    if (permissions?.calendars && permissions?.calendars.showMenu === true) {
      routeArr.push({ name: 'Users', to: './calender', icon: Icon6 });
    }
  } else {
    if (permissions?.availability && permissions?.availability.showMenu === true) {
      routeArr.push({ name: 'Schedule', to: './availability', icon: Icon2 });
    }
    if (permissions?.dashboard && permissions?.dashboard.showMenu === true) {
      routeArr.push({ name: 'Dashboard', to: './events', icon: Icon1 });
    }
    if (permissions?.calendars && permissions?.calendars.showMenu === true) {
      routeArr.push({ name: 'Calendars', to: './calender', icon: Icon6 });
    }
    if (permissions?.services && permissions?.services.showMenu === true) {
      routeArr.push({ name: 'Services', to: './services', icon: Icon3 });
    }
    if (
      permissions?.services &&
      permissions?.services.showMenu === true &&
      user?.offerings?.grooming === true &&
      user?.groomingTypes?.mobile === true
    ) {
      routeArr.push({ name: 'Mobile Route', to: './maps', icon: Icon3 });
    }
    //routeArr.push({ name: 'Quick Book Transactions', to: './quickbook-transactions', icon: Icon3 });

    if (permissions?.business && permissions?.business.showMenu === true) {
      routeArr.push({ name: 'Business Info', to: './businessinfo', icon: Icon4 });
    }
    if (permissions?.communication && permissions?.communication.showMenu === true) {
      routeArr.push({ name: 'Communication', to: './communication', icon: Icon10 });
    }
    if (permissions?.share && permissions?.share.showMenu === true) {
      routeArr.push({ name: 'Share a link', to: './sharelink', icon: Icon5 });
    }
    if (permissions?.dashboard && permissions?.dashboard?.showMenu === true) {
      routeArr.push({ name: 'Customers', to: './customers', icon: Customer });
    }
    if (permissions?.holidays && permissions?.holidays.showMenu === true) {
      routeArr.push({ name: 'Holidays', to: './holidays', icon: Icon7 });
    }
    if (permissions?.payment && permissions?.payment?.showMenu === true) {
      routeArr.push({ name: 'Settings', to: './settings', icon: Icon8 });
    }
    if (permissions?.petAttribute && permissions?.petAttribute?.showMenu === true) {
      routeArr.push({ name: 'Pet Attributes', to: './pet-attribute', icon: Icon8 });
    }
    if (permissions?.payment && permissions?.payment?.showMenu === true) {
      routeArr.push({ name: 'Plans & Billing', to: './billing', icon: Icon8 });
    }
    if (permissions?.petAttribute && permissions?.reviews?.showMenu === true) {
      routeArr.push({ name: 'Reviews', to: './reviews', icon: Icon9 });
    }
    if (permissions?.business && permissions?.business?.showMenu === true) {
      routeArr.push({ name: 'Reports', to: './reports', icon: Icon9 });
    }
    if (
      permissions?.availability &&
      permissions?.availability.showMenu === true &&
      (user?.offerings?.boarding === true || user?.offerings?.daycare === true)
    ) {
      routeArr.push({ name: 'Rooms', to: './rooms', icon: Icon9 });
    }
    // if (permissions?.petAttribute && permissions?.reviews?.showMenu === true) {
    //   routeArr.push({ name: 'Reviews', to: './reviews', icon: Icon9 });
    // }
  }
  const subscriptionDetails = user?.subscriptionDetails;
  let navigation: any = [];
  let navigationAfterLoginAsAdmin: any = [];
  if (
    (subscriptionDetails &&
      new Date(subscriptionDetails?.endDateTime) > new Date() &&
      subscriptionDetails?.status === 'trialing') ||
    subscriptionDetails?.status === 'active' ||
    subscriptionDetails?.status === 'past_due'
  ) {
    navigation = user?.isAdmin
      ? user?.businessUserRole?.name == SUPER_ADMIN_ROLE
        ? ([
            // { name: 'Payouts', to: './payout', icon: Icon8 },
            { name: 'Businesses', to: './businesses', icon: Icon1 },
            { name: 'Locations', to: './locations', icon: Marker },
            { name: 'Subscriptions', to: './subscriptions', icon: Icon1 },
            { name: 'Promotions', to: './promotions', icon: Icon1 },
            { name: 'App Config', to: './mobileapp', icon: Icon4 },
          ].filter(Boolean) as SideNavigationItem[])
        : ([
            { name: 'Schedule', to: './availability', icon: Icon2 },
            { name: 'Dashboard', to: './events', icon: Icon1 },
            { name: 'Mobile Route', to: './maps', icon: Icon1 },
            { name: 'Customers', to: './customers', icon: Customer },
          { name: 'Calendars', to: './calender', icon: Icon6 },
            { name: 'Services', to: './services', icon: Icon3 },
            { name: 'Rooms', to: './rooms', icon: Icon3 },
            { name: 'Communication', to: './communication', icon: Icon10 },
            { name: 'Intake Form', to: './intake-form', icon: IntakeFormMenuIcon },
          ]
            .filter((ele) => {
              if (ele.name == 'Mobile Route') {
                return user?.offerings?.grooming === true ? user?.groomingTypes?.mobile : false;
              }
              if (ele.name == 'Services') {
                return user?.offerings?.grooming === true ? true : false;
              }
              if (ele.name == 'Rooms') {
                return user?.offerings?.boarding || user?.offerings?.daycare ? true : false;
              }
              return true;
            })
            .filter(Boolean) as SideNavigationItem[])
      : routeArr && routeArr.length > 0
      ? (routeArr.filter(Boolean) as SideNavigationItem[])
      : ([
          { name: 'Schedule', to: './availability', icon: Icon2 },
          { name: 'Dashboard', to: './events', icon: Icon1 },
          { name: 'Mobile Route', to: './maps', icon: Icon1 },
          { name: 'Communication', to: './communication', icon: Icon10 },
          { name: 'Customers', to: './customers', icon: Customer },
          { name: 'Share a link', to: './sharelink', icon: Icon5 },
          { name: 'Holidays', to: './holidays', icon: Icon7 },
        ]
          .filter((ele) => {
            if (ele.name == 'Mobile Route') {
              return user?.offerings?.grooming === true ? user?.groomingTypes?.mobile : false;
            }
            return true;
          })
          .filter(Boolean) as SideNavigationItem[]);

    navigationAfterLoginAsAdmin =
      user?.isAdmin && user?.businessUserRole?.name !== SUPER_ADMIN_ROLE
        ? ([
            { name: 'Business Info', to: './businessinfo', icon: Icon4 },
            { name: 'Share a link', to: './sharelink', icon: Icon5 },
            { name: 'Reports', to: './reports', icon: IntakeFormMenuIcon },
            { name: 'Holidays', to: './holidays', icon: Icon7, count: 5 },
            { name: 'Settings', to: './settings', icon: Icon8 },
            { name: 'Reviews', to: './reviews', icon: Icon9 },
            { name: 'Pet Attributes', to: './pet-attribute', icon: MenuPetIcon },
            { name: 'Plans & Billing', to: './billing', icon: Icon8 },
          ].filter(Boolean) as SideNavigationItem[])
        : [];

    if (
      user?.activeLocation?.qbAuthorized &&
      user?.isAdmin &&
      user?.businessUserRole?.name !== SUPER_ADMIN_ROLE
    ) {
      navigationAfterLoginAsAdmin.push({
        name: 'Quickbooks',
        to: './quickbook-transactions',
        icon: Icon8,
      });
    }
  } else {
    navigationAfterLoginAsAdmin =
      user?.isAdmin && user?.businessUserRole?.name !== SUPER_ADMIN_ROLE
        ? ([{ name: 'Plans & Billing', to: './billing', icon: Icon8 }].filter(
            Boolean
          ) as SideNavigationItem[])
        : [];
  }

  const showEmily = permissions?.emily && permissions?.emily?.showMenu === true ? true : false;

  return (
    <div className="main-menu-outer">
      <div className="menu-parent-class">
        <div
          className="menu-back-nav"
          onClick={() => {
            setSidebarOpen(false);
          }}
        >
          <MenuBackIcon /> <span>Back</span>
        </div>
        <nav aria-label="Main Nav" className="flex flex-col space-y-1 update-menu-ui">
          {showEmily && (
            <>
              <div className="menu-title-text">Assistance</div>
              <span className="emily-assistant-menu">
                <Link
                  to="/emily-assistant"
                  onClick={() => {
                    setSidebarOpen(false);
                  }}
                  className={`side-menu-item emily flex items-center rounded-lg bg-gray-100 text-gray-700 anchor-btm ${
                    location.pathname === '/emily-assistant' ? 'active' : ''
                  }`}
                >
                  <span className="bg">
                    <span className="left-item">
                      <EmilyOtherMenu />
                      <span className="menu-name emily">Ask Emily</span>
                      <EmilyAIIcon />
                    </span>
                    <span className="beta">Beta</span>
                  </span>
                </Link>
              </span>
            </>
          )}

          <div className="menu-title-text mb-3">menu</div>
          {navigation.map((item: any, index: number) => (
            <Link
              key={index}
              to={item.to}
              onClick={() => {
                setSidebarOpen(false);
              }}
              className={`side-menu-item flex items-center rounded-lg bg-gray-100 px-4 py-2 text-gray-700 anchor-btm ${
                location.pathname == item.to.substring(1) ||
                (location.pathname == '/' && item.name == 'Schedule')
                  ? 'active'
                  : ''
              }`}
            >
              {item.name === 'Schedule' && <Icon2 />}
              {item.name === 'Dashboard' && <Icon1 />}
              {item.name === 'Mobile Route' && <Maps />}
              {item.name === 'Calendars' && <Calender />}
              {item.name === 'Services' && <Services />}
              {item.name === 'Availability' && <Schedule />}
              {item.name === 'Share a link' && <OtherMenu6 />}
              {item.name === 'Customers' && <CustomerIcon2 />}
              {item.name === 'Holidays' && <OtherMenu2 />}
              {item.name === 'Settings' && <OtherMenu1 />}
              {item.name === 'Reviews' && <OtherMenu4 />}
              {item.name === 'Pet Attributes' && <OtherMenu5 />}
              {item.name === 'Communication' && <OtherMenu7 />}
              {item.name === 'Plans & Billing' && <OtherMenu9 />}
              {item.name === 'Quickbooks' && <OtherMenu8 />}
              {item.name === 'Rooms' && <OtherMenu10 />}
              {item.name === 'Intake Form' && <IntakeFormMenuIcon />}
              {item.name === 'Reports' && <IntakeFormMenuIcon />}
              <span className="menu-name">{item.name}</span>
            </Link>
          ))}
          {/* <Link
            key={'intake-froms'}
            to={'/intake-form'}
            onClick={() => {
              setSidebarOpen(false);
            }}
            className={`side-menu-item flex items-center rounded-lg bg-gray-100 px-4 py-2 text-gray-700 anchor-btm ${
              location.pathname == '/intake-form'.substring(1) ? 'active' : ''
            }`}
          >
            <IntakeFormMenuIcon /> <span className="menu-name">Intake Form</span>
          </Link> */}
          {navigationAfterLoginAsAdmin && navigationAfterLoginAsAdmin.length > 0 && (
            <div className="menu-title-text others" onClick={() => setShowOthers(!showOthers)}>
              <ArrowIcon className={`arrow-icon ${showOthers ? 'expanded' : 'collapsed'}`} />
              others
            </div>
          )}
          <span className={`other-menu-items ${showOthers ? 'show' : 'hide'}`}>
            {navigationAfterLoginAsAdmin.map((item: any, index: number) => (
              <Link
                key={index}
                to={item.to}
                onClick={() => {
                  setSidebarOpen(false);
                }}
                className={`side-menu-item flex items-center rounded-lg bg-gray-100 px-4 py-2 text-gray-700 anchor-btm ${
                  location.pathname == item.to.substring(1) ? 'active-btm' : ''
                }`}
              >
                {item.name === 'Holidays' && <OtherMenu2 />}
                {item.name === 'Business Info' && <OtherMenu3 />}
                {item.name === 'Reviews' && <OtherMenu4 />}
                {item.name === 'Pet Attributes' && <OtherMenu5 />}
                {item.name === 'Share a link' && <OtherMenu6 />}
                {/* {item.name === 'Customers' && <CustomerIcon2 />} */}
                {item.name === 'Communication' && <OtherMenu7 />}
                {item.name === 'Plans & Billing' && <OtherMenu9 />}
                {item.name === 'Settings' && <OtherMenu1 />}
                {item.name === 'Quickbooks' && <OtherMenu8 />}
                {item.name === 'Rooms' && <OtherMenu10 />}
                {item.name === 'Intake Form' && <IntakeFormMenuIcon />}
                {item.name === 'Reports' && <IntakeFormMenuIcon />}

                <span className="menu-name">
                  {' '}
                  {item.name}{' '}
                  {item.name === 'Holidays' &&
                    user?.holidayCount !== undefined &&
                    user?.holidayCount !== 0 && (
                      <span className="show-count">{user?.holidayCount}</span>
                    )}
                </span>
              </Link>
            ))}
          </span>
        </nav>
      </div>
      <div className="sticky inset-x-0 bottom-0">
        {saToken ? (
          <div className="logout-outer">
            <a
              onClick={() => {
                storage.setToken(storage.getSAToken());
                storage.setKey('activeLocationId', storage.getKey('activeLocationIdAdmin'));
                storage.clearSAToken();
                storage.clearKey('activeLocationIdAdmin');
                window.location.assign((window.location.origin + APP_PATH) as unknown as string);
              }}
              className="log-out-class"
            >
              Go Back to Admin
            </a>
          </div>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

type MobileSidebarProps = {
  onNavigate: () => void;
  sidebarOpen: boolean;
  setSidebarOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

const canShowLocationDropDown = (user: any) => {
  if (
    location.pathname.includes('/new-location') ||
    location.pathname.includes('/business-hours/') ||
    user?.businessUserRole?.name == SUPER_ADMIN_ROLE
  ) {
    return false;
  } else {
    return true;
  }
};

const MobileSidebar = ({ sidebarOpen, setSidebarOpen, onNavigate }: MobileSidebarProps) => {
  const { user } = useAuth();
  const subscriptionDetails = user?.subscriptionDetails;
  let daysLeft = 0;
  let status = null;
  if (subscriptionDetails) {
    const eventdate = moment(subscriptionDetails.endDateTime);
    const todaysdate = moment();
    daysLeft = eventdate.diff(todaysdate, 'days');
    status =
      subscriptionDetails.status === 'trialing'
        ? 'active'
        : subscriptionDetails.status === 'past_due'
        ? 'Payment failed for Petsked premium plan'
        : subscriptionDetails.status;
  }
  return (
    <Transition.Root show={sidebarOpen} as={React.Fragment}>
      <Dialog
        as="div"
        static
        className="fixed inset-0 flex justify-st mobile-menu"
        open={sidebarOpen}
        onClose={setSidebarOpen}
      >
        <Transition.Child
          as={React.Fragment}
          enter="transition-opacity ease-linear duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="transition-opacity ease-linear duration-300"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <Dialog.Overlay className="fixed inset-0 bg-gray-600 bg-opacity-75" />
        </Transition.Child>
        <Transition.Child
          as={React.Fragment}
          enter="transition ease-in-out duration-300 transform"
          enterFrom="-translate-x-full"
          enterTo="translate-x-0"
          leave="transition ease-in-out duration-300 transform"
          leaveFrom="translate-x-0"
          leaveTo="-translate-x-full"
        >
          <div className="relative flex-1 flex flex-col w-sidebar w-full">
            <div className="h-0 menu-scr-height">
              <nav className="">
                <SideNavigation
                  sidebarOpen={sidebarOpen}
                  onNavigate={onNavigate}
                  setSidebarOpen={setSidebarOpen}
                />
                {status && (
                  <div className="subscription-details">
                    {subscriptionDetails.status !== 'past_due' && (
                      <div className="plan">{subscriptionDetails?.productName} Plan</div>
                    )}
                    <div className="status-details">
                      <span className={`current-status ${subscriptionDetails.status}`}>
                        {status}
                      </span>
                      {subscriptionDetails?.status === 'past_due' ? (
                        <>
                          <p className="trial-ends">
                            To use the features of the Premium plan, please complete the failed
                            payment.
                          </p>
                          {/* <p className="trial-ends">
                            Your {status === 'trialing' ? 'trial' : 'plan'} ends in {daysLeft} days
                          </p> */}
                        </>
                      ) : (
                        <>
                          {daysLeft > 0 ? (
                            <p className="trial-ends">
                              Your {status === 'trialing' ? 'trial' : 'plan'} ends in {daysLeft}{' '}
                              days
                            </p>
                          ) : (
                            <p className="trial-ends">
                              Your {status === 'trialing' ? 'trial' : 'plan'} ends today
                            </p>
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
                <div className="spacer"></div>
              </nav>
            </div>
          </div>
        </Transition.Child>
      </Dialog>
    </Transition.Root>
  );
};

const Sidebar = ({ sidebarOpen, setSidebarOpen, onNavigate }: MobileSidebarProps) => {
  const { user } = useAuth();
  const subscriptionDetails = user?.subscriptionDetails;
  let daysLeft = 0;
  let status = null;
  if (subscriptionDetails) {
    const eventdate = moment(subscriptionDetails.endDateTime);
    const todaysdate = moment();
    daysLeft = eventdate.diff(todaysdate, 'days');
    status =
      subscriptionDetails.status === 'trialing'
        ? 'active'
        : subscriptionDetails.status === 'past_due'
        ? 'Payment failed for Petsked premium plan'
        : subscriptionDetails.status;
  }
  return (
    <div className="sidebar-desktop flex-shrink-0">
      <div className="flex flex-col w-sidebar" id="sidebar">
        <div className="flex flex-col h-0 flex-1">
          {/* <Logo onNavigate={onNavigate}></Logo> */}
          <div className="flex-1 flex flex-col">
            <nav className="flex-1">
              <div className="flex flex-col justify-between custom-sidebar">
                <>
                  <SideNavigation
                    sidebarOpen={sidebarOpen}
                    onNavigate={onNavigate}
                    setSidebarOpen={setSidebarOpen}
                  />
                  {status && (
                    <div className="subscription-details">
                      {subscriptionDetails.status !== 'past_due' && (
                        <div className="plan">{subscriptionDetails?.productName} Plan</div>
                      )}
                      <div className="status-details">
                        <span className={`current-status ${subscriptionDetails.status}`}>
                          {status}
                        </span>
                        {subscriptionDetails?.status === 'past_due' ? (
                          <>
                            <p className="trial-ends">
                              To use the features of the Premium plan, please complete the failed
                              payment.
                            </p>
                            {/* <p className="trial-ends">
                            Your {status === 'trialing' ? 'trial' : 'plan'} ends in {daysLeft} days
                          </p> */}
                          </>
                        ) : (
                          <>
                            {daysLeft > 0 ? (
                              <p className="trial-ends">
                                Your {status === 'trialing' ? 'trial' : 'plan'} ends in {daysLeft}{' '}
                                days
                              </p>
                            ) : (
                              <p className="trial-ends">
                                Your {status === 'trialing' ? 'trial' : 'plan'} ends today
                              </p>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  )}
                </>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

type MainLayoutProps = {
  children: React.ReactNode;
};
export const MainLayout = ({ children }: MainLayoutProps) => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const [dinnerHeight, setInnerHeight] = React.useState(window.innerHeight);
  const navigate = useNavigate();
  const handleResize = () => {
    setInnerHeight(window.innerHeight);
  };
  const { user } = useAuth();
  React.useEffect(() => {
    // set resize listener
    window.addEventListener('resize', handleResize);

    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener('resize', handleResize);
    };
  }, []);
  const subscription = true;
  return (
    <div className="main-layout h-screen-min overflow-hidden" style={{ minHeight: dinnerHeight }}>
      <TopHeader
        onNavigate={() => {
          navigate('/');
        }}
        canShowLocationDropDown={canShowLocationDropDown(user)}
        setSidebarOpen={(value: boolean) => {
          setSidebarOpen(value);
        }}
      />
      <div className="flex bottom-section">
        {subscription && (
          <>
            <MobileSidebar
              onNavigate={() => {
                navigate('/');
              }}
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
            <Sidebar
              onNavigate={() => {
                navigate('/');
              }}
              sidebarOpen={sidebarOpen}
              setSidebarOpen={setSidebarOpen}
            />
          </>
        )}
        <div id="main-content" className="flex flex-col w-0 flex-1 overflow-hidden layout-outer">
          <main className="flex-1 relative focus:outline-none content-section">{children}</main>
        </div>
      </div>
    </div>
  );
};
